import React, { createContext, useContext, useState, useEffect } from 'react';

const NotificationsContext = createContext({
  unreadCount: 0,
  notifSlice: [],
});

export const useNotifications = () => useContext(NotificationsContext);

export const NotificationsProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifSlice,  setNotifSlice]  = useState([]);

  useEffect(() => {
    const handler = () => {
      // auth.js sets app.notificationCount and app.notificationSlice before firing this event
      const raw   = window.app?.notificationCount || '0';
      const count = raw === '99+' ? 99 : (parseInt(raw, 10) || 0);
      const rows  = window.app?.notificationSlice?.rows || [];
      setUnreadCount(count);
      setNotifSlice(rows);
    };

    document.addEventListener('notificationCount', handler);
    return () => document.removeEventListener('notificationCount', handler);
  }, []);

  return (
    <NotificationsContext.Provider value={{ unreadCount, notifSlice }}>
      {children}
    </NotificationsContext.Provider>
  );
};
